import { render } from "./TextDecorationWidget.vue?vue&type=template&id=6b262dc1&scoped=true"
import script from "./TextDecorationWidget.vue?vue&type=script&lang=js"
export * from "./TextDecorationWidget.vue?vue&type=script&lang=js"

import "./TextDecorationWidget.vue?vue&type=style&index=0&id=6b262dc1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b262dc1"]])

export default __exports__